import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { Dictionary } from '@app/core/models';
import { AdditionalFormData, FieldInfo, StatsAction, StatsOptionsForm } from './models';
import { Subject } from 'rxjs';

@Injectable()
export class StatsTransferService {
  info: WritableSignal<Dictionary<string, FieldInfo>> = signal({ });
  ready: Signal<boolean> = computed(() => Object.keys(this.info()).length > 0);

  formData: WritableSignal<AdditionalFormData> = signal(null);
  form: StatsOptionsForm;

  sharedSubject: Subject<StatsAction> = new Subject<StatsAction>();
}
